import React, { useEffect, useState } from "react";
import ViewIcon from "../BookModule/AdminSide/BookTabs/ViewIcon.png";
import CourierInfo from "./BookModule.module.css";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import { Link, useNavigate, useParams } from "react-router-dom";
import { R_PER_PAGE, } from "../../../../labels";
import moment from "moment";
export default function CourierDetails(props) {
  // ----------------Both Student(Add to CART /PaymentSuccess) and Admin (View Purchase page)-----
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let user_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      user_type = user.user_type;
    }
  } else {
    console.log("User Id not available in session storage");
  }
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  let page = R_PER_PAGE;
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);

  // total table data  with pages
  const totalPages = Math.ceil(props?.couItem?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const openInNewTab = (url) => {
    window.open("https://erpstcourier.com/inc/popup/awb_history.php?awb="+url, '_blank', 'noopener,noreferrer');
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  let currentData = props?.couItem?.slice(start, end);
  const handleCourierDetails = () => {
    navigate(`/AddNewCourierDetails`, {
      state: {
        purchase_id: props.idPur,
        labelStatus: 1,
        addressData: props.addressData,
      },
    });
  };
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = props?.couItem?.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        // console.log("zxcxzc", "sortedList", aValue == bValue, aValue, bValue);
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    currentData = sortedList;
    setSortColumn(sortKey);
  };
  return (
    <div className="row mx-0 mt-3">
      <div className="col-xl-12 col-lg-12 col-md-12 col-12 px-0">
        <fieldset className={CourierInfo.CourierContainer}>
          <legend className="w-auto mb-0">Courier Details</legend>
          {(user_type === 1 || user_type === 3 || user_type === 4) &&
            (props?.couItem?.length === 0 ||
              (props?.bookPur?.length > 0 &&
                props?.bookPur?.some((er) => er.delivery_status === 0))) && (
              <div className="col-md-12 col-12 ListBtn px-0">
                <ul class="List-Button">
                  <li class="ListBtnItems">
                    <Link
                      to="javascript:void(0)"
                      onClick={handleCourierDetails}
                      className="primaryButton text-center"
                      variant="primary"
                    >
                      Add New Courier Details
                    </Link>
                  </li>
                </ul>
              </div>
            )}
          {user_type === 2 && props?.couItem?.length === 0 && (
            <div className={CourierInfo.PreOrderNoteSec}>
              <p className={`${CourierInfo.couierNotesLabel} mb-0`}>
                <strong>NOTE: </strong> The parcel has not been picked up by the
                courier yet. Once it has been collected, you will be able to
                track your delivery. Please wait for further updates.
              </p>
            </div>
          )}
          <div className="row mt-3 mx-0">
            <div
              className={`col-md-12 ${CourierInfo.table_responsive_padding} table-responsive tableMinHeight px-0 `}
            >
              <table className="table" id="tableListHeader">
                <thead>
                  <tr>
                    <th id="th" className={CourierInfo.tableThPadding}>
                      <span className="textHead_th">Courier Date & Time</span>
                      {user_type === 1 && (
                        <span
                          onClick={(e) => handleSort(e, "created_dt")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      )}
                    </th>
                    <th id="th" className={CourierInfo.tableThPadding}>
                      <span className="textHead_th">Book Names</span>
                    </th>
                    <th id="th" className={CourierInfo.tableThPadding}>
                      <span className="textHead_th">Delivery Status</span>
                      {user_type === 1 && (
                        <span
                          onClick={(e) => handleSort(e, "delivery_status")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      )}
                    </th>
                    <th id="th" className={CourierInfo.tableThPadding}>
                      <span className="textHead_th">Tracking ID</span>
                    </th>
                    <th id="th" className={CourierInfo.tableThPadding}>
                      <span className="textHead_th">Action</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentData?.length === 0 ? (
                    <tr>
                      <td colspan="15" style={{ textAlign: "center" }}>
                        No records to display
                      </td>
                    </tr>
                  ) : (
                    currentData?.map((kl, ind) => (
                      <tr key={ind}>
                        <td id="td">
                          {kl.created_dt
                            ? moment(kl.created_dt).utc().format("DD/MM/YYYY hh:mm:ss a")
                            : "_"}
                        </td>
                        <td id="td">
                          <span
                            title={kl.bookTitles}
                            className={CourierInfo.ellipsisText}
                          >
                            {kl.bookTitles ? kl.bookTitles : "_"}
                          </span>
                        </td>

                        <td id="td">
                          <span
                            title={kl.delivery_status}
                            className={CourierInfo.ellipsisText}
                          >
                            {kl.delivery_status ? kl.delivery_status : "_"}
                          </span>
                          {/* {kl.delivery_status == 2 && (
                            <span
                              className={`${CourierInfo.deliveryStatus} ms-0  ${CourierInfo.deliveryStatusGreen}`}
                            >
                              {" "}
                              Delivered
                            </span>
                          )}
                          {kl.status_code == 1 && (
                            <span
                              className={`${CourierInfo.deliveryStatus} ms-0 ${CourierInfo.deliveryStatusYellow}`}
                            >
                              Shipping in Progress
                            </span>
                          )} */}
                        </td>
                        {/* <td id="td">
                          <div>
                            <span>
                              <img src={mapIcon} alt="MapLocationIcon" />
                            </span>
                            {user_type === 1 && (
                              <span className="mx-3">
                                <img
                                  src={ViewIcon}
                                  onClick={() =>
                                    handleNavigate(kl.id, kl.order_pk)
                                  }
                                  alt="view icon"
                                />
                              </span>
                            )}
                          </div>
                        </td> */}

                        { (kl.tracking_id !== undefined) ? (
                          <td id="td">{kl.tracking_id }</td>
                        ):
                        <td id="td">{"-"}</td>
                        }
                        <td id="td">{kl.tracking_id ? <img
                                                    src={ViewIcon}
                                                    onClick={() => openInNewTab(kl.tracking_id) }
                                                    className={CourierInfo.cursor_pointer}
                                                    alt="view icon"
                                                  />: ""}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="row mt-2">
            <Pagination
              rowsPerPage={rowsPerPage}
              handlePageCount={handlePageCount}
              startPage={
                currentData && currentData?.length > 0
                  ? currentPage * rowsPerPage + 1 - rowsPerPage
                  : 0
              }
              endPage={
                currentData && currentData?.length > 0
                  ? currentData.length < currentPage * rowsPerPage
                    ? currentData?.length
                    : currentPage * rowsPerPage
                  : 0
              }
              totalRecords={
                currentData && currentData?.length > 0 ? currentData?.length : 0
              }
              handlePrev={(e) => handlePrev(currentPage - 1)}
              currentPrevPage={currentPage === 1}
              prevButton={`${CourierInfo.prev_buttonViewAllbook} ${CourierInfo.materialIconsRightAndLeft} me-2`}
              handleNext={() => handleNext(currentPage + 1)}
              currentNextPage={totalPages == 0 || currentPage === totalPages}
            />
          </div>
        </fieldset>
      </div>
    </div>
  );
}
